import CryptoJS from 'crypto-js'
export default {//加密
    encrypt(word, keyStr){
        keyStr = keyStr ? keyStr : 'abcdefgabcdefg12';
        var key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
        var srcs = CryptoJS.enc.Utf8.parse(word);
        var encrypted = CryptoJS.AES.encrypt(srcs, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
        return encrypted.toString();
    },
    //解密
    decrypt(word, keyStr){
        keyStr = keyStr ? keyStr : 'abcdefgabcdefg12';
        var key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
        var decrypt = CryptoJS.AES.decrypt(word, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
        return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    },
    /**
     * 获取URL中的参数
     * @param name
     * @returns {string}
     */
    getQueryString(name) {
        var reg = new RegExp("(^|&|[?])" + name + "=([^&]*)(&|$)")
        var r = window.location.href.substr(1).match(reg)
        var newName = (r != null ? r[2] : "")
        return newName
    },
    getURLs(url){
        let strURL = "";
        if(url.substr(0,7).toLowerCase() == "http://" || url.substr(0,8).toLowerCase() == "https://"){
            strURL = url;
        }else{
            strURL = "https://" + url;
        }
        return strURL;
    },
    bjBigSmall(value){
        //取出最违规
        if (value) {
            var arr = []
            for (let i in value) {
                if(value[i]>0) arr.push(value[i])
            }
            let max = arr[0];
            for (let i = 0; i < arr.length - 1; i++) {
                if(arr[i]>0){
                    max = max > arr[i+1] ? arr[i+1] : max
                }
            }
            return max;
        }
    },
    objToArr(val){
        var arrObj = []
        if(val){
            for (let i in val) {
                arrObj.push({'name':i,'val':val[i]})
            }
        }
        return arrObj;
    }
}
